import { SVGInterface } from "../../interface";

const ExceptionTracker = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M10.8001 1.66602C6.20513 1.66602 2.4668 5.40435 2.4668 9.99935C2.4668 14.5943 6.20513 18.3327 10.8001 18.3327C15.3951 18.3327 19.1335 14.5943 19.1335 9.99935H17.4668C17.4668 13.6752 14.476 16.666 10.8001 16.666C7.1243 16.666 4.13346 13.6752 4.13346 9.99935C4.13346 6.32352 7.1243 3.33268 10.8001 3.33268C12.6376 3.33268 14.3025 4.08403 15.5088 5.29069L13.3001 7.49935H19.1335V1.66602L16.6839 4.11556C15.1766 2.60457 13.0979 1.66602 10.8001 1.66602ZM9.9668 5.83268V10.8327H11.6335V5.83268H9.9668ZM9.9668 12.4993V14.166H11.6335V12.4993H9.9668Z"
      fill={color || "black"}
    />
  </svg>
);

export default ExceptionTracker;
